<form>
  <ng-container *transloco="let t; read: 'ime.manufacturing.cost-price-components'">
    <div class="form-group row">
      <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" name="code" id="code" [(ngModel)]="cpc.Code">
      </div>
    </div>
    <div class="form-group row">
      <label for="description" class="col-sm-4 col-form-label">{{t('Description')}}</label>
      <div class="col-sm-8">
        <textarea class="form-control" name="description" id="description" [(ngModel)]="cpc.Description"></textarea>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-sm-4 col-form-label">{{t('Type')}}</label>
      <div class="col-sm-8">
        <mes-web-classificator-value-select [entityId]="cpc.TypeClv" (entityIdChange)="cpc.TypeClv = $event" name="type" id="type"
                                            [items$]="classificatorValueService.costPriceComponentTypes$" [allowAdd]="false">
        </mes-web-classificator-value-select>
      </div>
    </div>

    <div class="w-100"></div>

    <div class="card">
      <div class="card-body">
        <h5 class="card-title">{{t('Surcharges')}}</h5>
        <table class="table table-borderless">
          <thead class="table-light">
          <tr class="d-flex">
            <th scope="col" class="col-3">{{t('Code')}}</th>
            <th scope="col" class="col-3">{{t('Price')}}</th>
            <th scope="col" class="col-3">{{t('From/To')}}</th>
            <th scope="col" class="col-2">{{t('Type')}}</th>
            <th scope="col" class="col-1"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let surcharge of cpc.CostPriceComponentSurcharges; let index=index;" class="d-flex">
            <td class="col-3">
              <mes-cost-price-component-select name="cpc-{{index}}"
                                               [items$]="cpcService.getAll$"
                                               [entityId]="surcharge.SurchargeId"
                                               (entityIdChange)="surcharge.SurchargeId = $event"></mes-cost-price-component-select>
            </td>
            <td class="col-2">
              <input class="form-control form-control-sm" id="price-{{index}}" name="price-{{index}}" [decimalPlaces]="6" [(mesNumberInput)]="surcharge.Price" (onChange)="setChanged()">
            </td>
            <td class="col-4">
              <mes-date-range-picker [fromDate]="surcharge.FromDate" [toDate]="surcharge.ToDate"
                                     (dateSelect)="setDateRange($event, surcharge)"></mes-date-range-picker>
            </td>
            <td class="col-2">
              <mes-web-classificator-value-select name='surcharge-type-{{index}}' [entityId]="surcharge.TypeClv"
                                                  (entityIdChange)="surcharge.TypeClv = $event"
                                                  [items$]="classificatorValueService.costPriceComponentSurchargeTypes$" [allowAdd]="false"></mes-web-classificator-value-select>
            </td>
            <td class="col-1">
              <button class="btn btn-sm btn-outline-danger" (click)="remove(surcharge)">
                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <footer class="row">
          <div class="col text-end">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addSurcharge()">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
              {{t('Surcharge')}}
            </button>
          </div>
        </footer>
      </div>
    </div>
  </ng-container>
</form>
